module.exports = __webpack_public_path__ + "static/media/Delivery.79db1b89.svg";